import { DatePicker, Input, Select, notification } from 'antd';
import React, { useEffect, useState } from 'react';
import FormWrapper from './FormWrapper';
import FormActionButton from '../../ui/FormActionButton';
import Title from '../../ui/Title';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import dayjs from 'dayjs';
import { fetchProducts } from '../../../store/slices/product-slice';
import { fetchIssuers } from '../../../store/slices/issuer-slice';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const USER_NAME = process.env.REACT_APP_USER_NAME;
const PASSWORD = process.env.REACT_APP_PASSWORD;

const ProductForm = () => {

    const [issuerList, setIssuerList] = useState([]);

    const [productName, setProductName] = useState('');
    const [issuerId, setIssuerId] = useState('');
    const [isin, setISIN] = useState('');
    const [couponRate, setCouponRate] = useState('');
    const [tenureMaturity, setTenureMaturity] = useState('');
    const [rics, setRICS] = useState('');
    const [issuedDate, setIssuedDate] = useState({
        dateValue: '',
        dateString: '',
    });
    
    const [api, contextHolder] = notification.useNotification();

    const [searchParams] = useSearchParams();
    const MODE = searchParams.get('mode');
    const navigate = useNavigate();
    const { data: products } = useSelector((state) => state.product);
    const { data: issuers } = useSelector((state) => state.issuer);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchProducts());
        dispatch(fetchIssuers());
    }, []);

    useEffect(() => {
        if(MODE === 'EDIT' && products.length) {
            const ID = searchParams.get('id');
            const selectedProduct = products.filter((item) => item.prod_id === ID);
            setProductName(selectedProduct[0].prod_name);
            setIssuerId(selectedProduct[0].issuer_id);
            setISIN(selectedProduct[0].ISIN);
            setCouponRate(selectedProduct[0].coupon_rate);
            setTenureMaturity(selectedProduct[0].tenure_maturity);
            setRICS(selectedProduct[0].RICS);
            selectedProduct[0].issued_date && 
            setIssuedDate({ 
                dateValue: dayjs(selectedProduct[0].issued_date.split(' ')[0]), 
                dateString: selectedProduct[0].issued_date.split(' ')[0] 
            });
        }
        if(MODE === 'ADD') {
            resetHandler();
        }
    }, [MODE, products]);

    useEffect(() => {
        if (issuers.length>0) {
            setIssuerList(issuers.map((issuer) => (
                { value: issuer.issuer_id, label: issuer.issuer_name }
            )));
        }
    }, [issuers]);

    const openNotification = ({type, message, description}) => {
        api[type]({
            message,
            description,
            placement: 'bottomRight',
        });
    }

    const submitHandler = async (e) => {
        e.preventDefault();
        const details = {
            'prod_name': productName,
            'issuer_id': issuerId,
            'issued_date': issuedDate.dateString,
            'ISIN': isin,
            'coupon_rate': couponRate,
            'tenure_maturity': tenureMaturity,
            'RICS': rics
        };
        if(MODE === 'EDIT') {
            const ID = searchParams.get('id');
            details.prod_id = ID;
        }

        var formBody = [];
        for (var property in details) {
        var encodedKey = encodeURIComponent(property);
        var encodedValue = encodeURIComponent(details[property]);
        formBody.push(encodedKey + "=" + encodedValue);
        }
        formBody = formBody.join("&");

        try {
            const response = await fetch(`${API_BASE_URL}/product/${MODE === 'ADD' ? 'add' : 'edit'}`, {
                method: 'POST',
                headers: { 
                    'Authorization': 'Basic ' + btoa(`${USER_NAME}:${PASSWORD}`),
                    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
                body: formBody
            });
            const responseData = await response.json();

            if(responseData.code === 200) {
                openNotification(
                    { 
                        type: 'success',
                        message: 'Successfully Submitted!', 
                        description: responseData.message,
                    }
                );
                resetHandler();
                if(MODE === 'EDIT') {
                    setTimeout(() => {
                        navigate('/dashboard/product-list');
                    }, 1500);
                }
            } else {
                openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        description: responseData.message,
                    }
                );
            }
        } catch (error) {
            openNotification(
                    { 
                        type: 'error',
                        message: 'Failed to Submit!', 
                        // description: error,
                    }
                );
        }
        
        
    }
    const resetHandler = () => {
        setProductName('');
        setIssuerId('');
        setISIN('');
        setCouponRate('');
        setTenureMaturity('');
        setRICS('');
        setIssuedDate('');
    }
    return (
        <FormWrapper>
            {contextHolder}
            <Title>{MODE} Product</Title>
            <form onSubmit={submitHandler}>
                <div className='control'>
                    <label>Product Name:</label>
                    <Input 
                        onChange={(e) => setProductName(e.target.value)} 
                        value={productName}
                        size='large' 
                        placeholder='Product Name' 
                    />
                </div>
                <div className='control'>
                    <label>Issuer:</label>
                    <Select
                        placeholder="Select Issuer"
                        style={{ width: '100%' }}
                        size='large'
                        onChange={(value) => setIssuerId(value)}
                        options={issuerList}
                        allowClear
                        {...(issuerId && { value: issuerId })}
                    />
                </div>
                <div className='control'>
                    <label>Issued Date:</label>
                    <div style={{width: '100%'}}>
                        <DatePicker 
                            onChange={(date, dateString) => setIssuedDate({ dateValue: date, dateString: dateString })} 
                            value={issuedDate.dateValue}
                            size='large' 
                            style={{width: '100%', borderRadius: '0.2rem'}} 
                        />
                    </div>
                </div>
                <div className='control'>
                    <label>ISIN:</label>
                    <Input 
                        onChange={(e) => setISIN(e.target.value)} 
                        value={isin}
                        size='large' 
                        placeholder='ISIN' 
                    />
                </div>
                <div className='control'>
                    <label>Coupon Rate:</label>
                    <Input 
                        onChange={(e) => setCouponRate(e.target.value)} 
                        value={couponRate}
                        size='large' 
                        placeholder='Coupon Rate' 
                    />
                </div>
                <div className='control'>
                    <label>Tenure Maturity:</label>
                    <Input 
                        onChange={(e) => setTenureMaturity(e.target.value)} 
                        value={tenureMaturity}
                        size='large' 
                        placeholder='Tenure Maturity' 
                    />
                </div>
                <div className='control'>
                    <label>RICS:</label>
                    <Input 
                        onChange={(e) => setRICS(e.target.value)} 
                        value={rics}
                        size='large' 
                        placeholder='RICS' 
                    />
                </div>
                <div className='control'>
                    <FormActionButton bg='#ff6b6b' onClick={resetHandler} type='button'>
                        Reset 
                    </FormActionButton>
                    <FormActionButton type='submit' bg='#10ac84'>
                        Submit 
                    </FormActionButton>
                </div>
            </form>
        </FormWrapper>
    );
}

export default ProductForm;

